// services
import AxiosInstanceCreator from 'services/api';

// models
import {
  ReqRAApprovalProps,
  ResRAApprovalHistoryProps,
  ResRAApprovalProps
} from '../models/riskAssessmentApproval.model';
import { ResultBaseProps } from 'modules/common';

const riskAssessmentInstance = new AxiosInstanceCreator({
  baseURL: `/v1/api/risk-assessment/approval`
}).create();

export const riskAssessmentApprovalApi = {
  /**
   * 위험성평가서 결재 목록 조회 API
   * @param {ReqRAApprovalProps} params
   * @returns {Promise<ResRAApprovalProps>}
   */
  async getRAApproval(params: ReqRAApprovalProps): Promise<ResRAApprovalProps> {
    return await riskAssessmentInstance.get(``, { params }).then((res) => res.data);
  },

  /**
   * 위험성평가서 결재 이력 조회 API
   * @param {number} riskAssessmentId
   * @returns {Promise<ResRAApprovalHistoryProps>}
   */
  async getRAApprovalHistory(riskAssessmentId: number): Promise<ResRAApprovalHistoryProps> {
    return await riskAssessmentInstance.get(`/history/${riskAssessmentId}`).then((res) => res.data);
  },

  /**
   * 결재 상신 API
   * @param {FormData} data
   * @returns {Promise<ResultBaseProps>}
   */
  async submitRAApproval(data: FormData): Promise<ResultBaseProps> {
    return await riskAssessmentInstance
      .patch(`/submit`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res.data);
  },

  /**
   * 결재 회수 API
   * @param {number} riskAssessmentId
   * @returns {Promise<ResultBaseProps>}
   */
  async retrieveRAApproval(riskAssessmentId: number): Promise<ResultBaseProps> {
    return await riskAssessmentInstance
      .patch(`/retrieve`, { riskAssessmentId })
      .then((res) => res.data);
  },

  /**
   * 결재 반려 API
   * @param {FormData} data
   * @returns {Promise<ResultBaseProps>}
   */
  async denyRAApproval(data: FormData): Promise<ResultBaseProps> {
    return await riskAssessmentInstance
      .patch(`/deny`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res.data);
  },

  /**
   * 결재 승인 API
   * @param {FormData} data
   * @returns {Promise<ResultBaseProps>}
   */
  async approveRAApproval(data: FormData): Promise<ResultBaseProps> {
    return await riskAssessmentInstance
      .patch(`/approve`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res.data);
  }
};
